export const maskIds = url => {
  return (url && typeof (url) === 'string')
    ? url.replace(/\/\d+/g, '/[id]')
      .replace(/\/configuration-keys\/[^/]+\//g, '/configuration-keys/[code]/')
    : url
}

export default {
  maskIds
}
